import { create } from "zustand";
import { TGiftCodeDetails } from "./types";

type TRedeemGiftState = {
  giftCodeDetails?: TGiftCodeDetails | null;
  isRedeeming: boolean;
  isAuthenticating: boolean;
  isVerifying: boolean;
};

type TRedeemGiftMethods = {
  setGiftFlow: (newState: Partial<TRedeemGiftState>) => void;
};

export const useGiftFlowStore = create<TRedeemGiftState & TRedeemGiftMethods>(
  (set) => {
    return {
      giftCodeDetails: null,
      isRedeeming: false,
      isAuthenticating: false,
      isVerifying: false,
      setGiftFlow: (newState) => set(newState),
    };
  }
);
